import React from 'react';
import ChatBot from '@/components/ChatBot/ChatBot';
import BackgroundPages from '@/global/Background/BackgroundPages';
import useScrollWindow from '@/hooks/useScrollWindow';

export default function ChatBotPage() {
  const { isMobile, isTablet } = useScrollWindow();
  const isDesktop = !isMobile && !isTablet;

  return (
    <React.Fragment>
      <div className="apply-trial-page">
        <BackgroundPages />
        <div className="relative z-10" style={{ minHeight: '100vh', marginTop: isDesktop ? '0' : '7rem' }}>
          <header className="aida-banner-wrapper mb-2 row justify-center">
            <img
              src="/static/images/AIDA-removebg.png"
              alt="AIDA - DISGENET Assistant"
              className="aida-banner"
              style={{ width: '100%', maxWidth: '30%', height: 'auto', display: 'block' }}
            />
          </header>
          <ChatBot />
        </div>
      </div>
    </React.Fragment>
  );
}
